import { render, staticRenderFns } from "./preference-widget-source-response-card.vue?vue&type=template&id=57c9c9e3"
import script from "./preference-widget-source-response-card.vue?vue&type=script&lang=js"
export * from "./preference-widget-source-response-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports